import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: "calc(100vh - 185px)",
    overflowY: "auto",
    paddingTop: theme.spacing(1),
  },
  viewButtons: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: theme.spacing(2),
    flexWrap: "wrap",
  },
  headerLeft: {
    display: "flex",
    alignItems: "start",
    flexWrap: "wrap",
    flexDirection: "column",
  },
  statusBadge: {
    borderRadius: 999,
    display: "inline-flex",
    alignItems: "center",
    fontSize: 5,
    lineHeight: 1,
    padding: theme.spacing(1, 1.5),
    textTransform: "uppercase",
    letterSpacing: 0.5,
    marginRight: "3px",
  },
  statusText: {
    fontSize: "14px !important"
  },
  badgeGray: {
    backgroundColor: "#E5E7EB",
    color: "#374151",
  },
  badgeBlue: {
    backgroundColor: "#DBEAFE",
    color: "#1D4ED8",
  },
  badgeRed: {
    backgroundColor: "#FEE2E2",
    color: "#B91C1C",
  },
  badgeGreen: {
    backgroundColor: "#DCFCE7",
    color: "#15803D",
  },
  badgeAmber: {
    backgroundColor: "#FEF3C7",
    color: "#B45309",
  },
  statusBar: {
    borderRadius: theme.spacing(1),
    border: "1px solid transparent",
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
  },
  alertGray: {
    backgroundColor: "#F9FAFB",
    borderColor: "#D1D5DB",
    color: "#374151",
  },
  alertBlue: {
    backgroundColor: "#EFF6FF",
    borderColor: "#BFDBFE",
    color: "#1E40AF",
  },
  alertRed: {
    backgroundColor: "#FEF2F2",
    borderColor: "#FECACA",
    color: "#B91C1C",
  },
  alertAmber: {
    backgroundColor: "#FFFBEB",
    borderColor: "#FDE68A",
    color: "#92400E",
  },
  statusBarText: {
    fontWeight: 500,
  },

  sectionTitle: {
    marginTop: theme.spacing(2),
  },
  sectionCard: {
    marginTop: theme.spacing(2),
    border: "1px solid #E8E0D5",
    borderRadius: theme.spacing(2),
    overflow: "hidden",
    backgroundColor: "#FFFFFF",
    padding: "10px",
  },
  tabsHeader: {
    borderBottom: "1px solid #EDE5DA",
    padding: theme.spacing(0, 2),
  },
  tabPanel: {
    padding: theme.spacing(3),
  },
  sectionLabel: {
    color: "#7E705F",
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 0.6,
    textTransform: "uppercase",
    marginBottom: theme.spacing(1.5),
  },
  uploadBox: {
    minHeight: 110,
    border: "1px dashed #E5DCCF",
    borderRadius: theme.spacing(1.5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(2.5),
    backgroundColor: "#FFFEFC",
    textAlign: "center",
  },
  uploadBoxDisabled: {
    backgroundColor: "#F8F6F2",
    color: "#9C9386",
  },
  helperTextMuted: {
    color: "#8E8072",
  },
  documentRow: {
    display: "grid",
    gridTemplateColumns: "32px minmax(0, 1fr) auto auto",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.75, 0),
    borderBottom: "1px solid #F1E9DF",
  },
  documentName: {
    color: "#1F2A37",
    fontWeight: 500,
  },
  documentMeta: {
    color: "#8E8072",
  },
  actionsHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    flexWrap: "wrap",
  },
  actionsTableHeader: {
    display: "grid",
    gridTemplateColumns: "2fr 1.5fr 1fr 1fr",
    gap: theme.spacing(1.5),
    padding: theme.spacing(0, 2, 1.5),
    borderBottom: "1px solid #E8E0D5",
    color: "#7E705F",
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 0.6,
    textTransform: "uppercase",
  },
  actionsRow: {
    display: "grid",
    gridTemplateColumns: "2fr 1.5fr 1fr 1fr",
    gap: theme.spacing(1.5),
    padding: theme.spacing(2),
    borderBottom: "1px solid #F1E9DF",
    alignItems: "center",
  },
  actionDetail: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.25),
  },
  actionTitle: {
    color: "#1F2A37",
    fontWeight: 500,
  },
  actionSubtitle: {
    color: "#8E8072",
    fontSize: 13,
  },
  statusPill: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 999,
    padding: theme.spacing(0.625, 1.5),
    fontSize: 12,
    fontWeight: 600,
    width: "fit-content",
  },
  statusPillWarning: {
    backgroundColor: "#FFF0C2",
    color: "#9A6400",
  },
  statusPillSuccess: {
    backgroundColor: "#E4F4E8",
    color: "#2E7D32",
  },
  errorText: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(1.25),
  },
  submitButtonBox: {
    display: "flex",
    justifyContent: "end",
  },
  followUpHeader: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginBottom: 16,
  },

  followUpBadge: {
    backgroundColor: "#e8f0fe",
    color: "#1a73e8",
    fontSize: 11,
    fontWeight: 700,
    borderRadius: 12,
    padding: "4px 10px",
    lineHeight: 1.4,
    textTransform: "uppercase",
  },

  automatedReminderWrapper: {
    marginTop: 8,
  },

  automatedReminderRow: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "14px 0",
  },

  automatedReminderRowBorder: {
    borderBottom: "1px solid #ece7e2",
  },

  automatedReminderIcon: {
    width: 18,
    height: 18,
    minWidth: 18,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#2e7d32",
    border: "1px solid #2e7d32",
    fontSize: 12,
    fontWeight: 700,
    lineHeight: 1,
  },

  automatedReminderText: {
    fontSize: 14,
    color: "#4b5563",
    lineHeight: "20px",
  },
  
  labelStyle: {
    fontWeight: 500,
    minWidth: 120,
    color: "#1a73e8",
  },
  actionPreview: {
    border: "1px solid #c6dafc !important",
    borderRadius: "8px !important",
    backgroundColor: "#f5f9ff",
    padding: "5px !important",
  }
}));
